import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class Model_1
*  
*/
export class Model_1 extends ActiveModel {

/**
  * Name
  * Пользовательское название файла<br>
  */
  @ActiveField()
  Name?: string


/**
  * File
  * Данные файла<br>
  */
  @ActiveField('')
  File: string = ''


  /**
  * IgnoreImageCheck
  * Если true, то проверка файла на то, что он является изображением, не выполняется,<br>соответственно в дальнейшем этот файл никак не распознаётся в виде изображения<br>  */
  @ActiveField()
  IgnoreImageCheck?: boolean
}
